export default __webpack_public_path__ + "static/media/Banner_Latam.de75c89c.png";